import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  marginTop: "-15px", // use to remove topPanel ShipeeziGrid
  "& table": {
    borderRadius: "8px",
    "& th:first-child": {
      borderTopLeftRadius: "8px",
    },
    "& th:last-child": {
      borderTopRightRadius: "8px",
    },
    "& tr:last-child > td:last-child": {
      borderBottomRightRadius: "8px",
    },
    "& tr:last-child > td:first-child ": {
      borderBottomLeftRadius: "8px",
    },
  },
}));
